"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.randomId = void 0;
var minDefault = Math.ceil(1);
var maxDefault = Math.floor(100000000000);
/**
 *
 * @param {int} min
 * @param {int} max
 * @return {number}
 */
// eslint-disable-next-line import/prefer-default-export, max-len

var randomId = function randomId() {
  var min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : minDefault;
  var max = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : maxDefault;
  return Math.floor(Math.random() * (max - min)) + min;
};

exports.randomId = randomId;